import { render } from "./Inscriptos.vue?vue&type=template&id=33e11964"
import script from "./Inscriptos.vue?vue&type=script&lang=js"
export * from "./Inscriptos.vue?vue&type=script&lang=js"

import "./Inscriptos.vue?vue&type=style&index=0&id=33e11964&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__